import React, { Component } from "react";
import { Route } from "react-router";
import { Layout } from "./components/Layout";
import { Home } from "./components/Home";
import { GraphData } from "./components/GraphData";
import { TabOrder } from "./components/TabOrder";
import { EngOrder } from "./components/EngineeringOrder";
import "./custom.css";
import { withAuth } from "./msal/MsalAuthProvider";

class RootApp extends Component {
	render() {
		return (
			<Layout {...this.props}>
				<Route exact path="/" component={Home} />
				<Route exact path="/Order/:branchId/:sizeId" component={TabOrder} />
				<Route exact path="/Order/Engineering" component={EngOrder} />
			</Layout>
		);
	}
}
export const App = withAuth(RootApp);
